@if (isInitialized) {
  <oe-chart [title]="component.alias">
    <oe-controller-io-heatingelement-chart [isOnlyChart]="true" [component]="component">
    </oe-controller-io-heatingelement-chart>
  </oe-chart>
}
